import axios from 'axios';

// const ACCESS_TOKEN = "pat-eu1-38afc7de-ac29-4604-b8bc-68ed0d8d4b69"


const Hubspot = async (fields, formGuid, context) => {
  const portalId = '139761212';
  const axiosConfig = { 
    headers: {
      'Content-Type': 'application/json',
    }
  }

  const formData = {
    fields,
    context,
  }

  const response = await axios.post(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
    formData,
    axiosConfig
  );
  return response;
}



export default Hubspot;

